let Groups = {
    init() {
        this.bind();
    },

    bind() {
        this.addForm();
        this.editForm();
        this.form();
        this.delete();
        this.usersAutocomplete();
    },

    addForm() {
        let _this = this;

        const form = $('#groupForm');

        if (form.length) {
            $(document).on('click', '.add-group', () => {
                form.find('#groupId').val('');
                form.find('#groupName').val('');
                form.find('#groupLocation').val('');
                form.find('#groupPrimaryUserId').val('');
                form.find('.group-admin-alert').hide();
                let users = [];

                _this.reloadUsersSelect(users);


                form.resetForm();
            });
            let submitBtn = Ladda.create(form.find('[type=submit]')[0]);

            form.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        window.location.reload();
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }
    },

    editForm() {
        let _this = this;

        const form = $('#groupForm');
        const modal = $('#groupModal');

        $(document).on('click', '.edit-group', function () {
            const id = $(this).data('id');
            const row = $(this).closest('tr');

            $.get('/groups/' + id + '/json', response => {
                if (response.success) {
                    const group = response.data;

                    let users = [
                        {
                            id: group.primary_user_id,
                            text: group.primary_user_name
                        }
                    ];

                    _this.reloadUsersSelect(users);

                    form.find('#groupName').val(group.name);
                    form.find('#groupLocation').val(group.location);
                    form.find('#groupPrimaryUserId').val(group.primary_user_id);
                    form.find('#groupId').val(group.id);

                    form.find('#groupPrimaryUserId').change();

                    form.find('.group-admin-alert').show();

                    modal.modal('show');
                }
            });
        });
    },

    delete() {
        $(document).on('click', '.delete-group', function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this record!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/groups/' + id,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'Group has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    form() {
        let _this = this;
        const form = $('#groupForm');
    },

    usersAutocomplete() {
        $('#groupPrimaryUserId').select2({});
    },

    reloadUsersSelect(users) {
        let _this = this;
        const elem = $('#groupPrimaryUserId');

        elem.empty();
        elem.select2('destroy');
        elem.select2({
            data: users,
            ajax: {
                url: '/groups/users/autocomplete',
                dataType: 'json',
                processResults: function (data) {
                    return {
                        results: data.items
                    };
                },
            },
            
            placeholder: 'Select Group Owner ...',
            minimumInputLength: 3,
        });
    },
};

$().ready(function () {
    window.Groups = Groups;
    window.Groups.init();
});
